import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { Maybe } from 'types/UtilityTypes';
import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

type CargoValueDefaultResponse = {
  declaredValueUSD: Maybe<number>;
};

/**
 * The cargo insurance (USD) Load Building pre-fills for a customer. The backend owns the
 * per-tenant rule; null means the tenant has no default and the field is left alone.
 */
export async function getCargoValueDefault(
  tmsID: number,
  customerName: string
): Promise<Result<Maybe<number>, ApiError>> {
  try {
    const params = new URLSearchParams({
      tmsID: String(tmsID),
      customerName,
    });
    const response = await axios.get<CargoValueDefaultResponse>(
      `/load/options/cargo-value?${params.toString()}`
    );
    return ok(response.data.declaredValueUSD ?? null);
  } catch (error) {
    captureException(error, { functionName: 'getCargoValueDefault' });
    return err({ message: 'Failed to get the default cargo value' });
  }
}
